const PROJECT_ID_PATTERN = /^[a-z0-9_-]{20,}$/i;

export function normalizeProjectId(value) {
  if (typeof value === 'string') {
    return value.trim();
  }

  if (value && typeof value === 'object') {
    if (typeof value._id === 'string') return value._id;
    if (typeof value.id === 'string') return value.id;
  }

  return '';
}

export function isValidProjectId(value) {
  const normalized = normalizeProjectId(value);
  return PROJECT_ID_PATTERN.test(normalized);
}
